import { ReactNode } from 'react';
import reactStringReplace from 'react-string-replace';

import { flagSizes } from '@monoimin/sb-types';
import { COUNTRY_CODE_REGEX } from '@monoimin/constants';

import { Flag } from '../Flag';

const forceArray = (el: any) => (Array.isArray(el) ? el : [el]);

export const handleReplaceFlag = ({
  children,
  size,
  className,
}: {
  children: ReactNode;
  size?: flagSizes;
  className?: string;
}) =>
  reactStringReplace(forceArray(children), COUNTRY_CODE_REGEX, (match, i) => {
    return (
      <Flag
        key={`${match}_${i}`}
        size={size}
        countryCode={match.substring(1)}
        className={className}
      />
    );
  });
